<template>
  <MgdDialog :open="open" @update:open="onUpdateOpen">
    <MgdDialogContent>
      <MgdDialogHeader>
        <MgdDialogTitle>Report a Bug</MgdDialogTitle>
        <MgdDialogDescription>
          If you are experiencing an issue, please let us know below.
        </MgdDialogDescription>
      </MgdDialogHeader>
      <p v-if="bugReportError">
        There was an error submitting your bug report. {{ bugReportError }}
      </p>
      <template v-if="bugReportData">
        <p>Your bug report has been submitted. Thank you for your feedback!</p>
        <p>Report ID: {{ bugReportData.reportId }}</p>
      </template>
      <form v-else class="space-y-4" @submit="onSubmit">
        <FormFieldTextarea
          label="What are you experiencing?"
          name="description"
          class="h-full"
          rows="8"
          placeholder="Please provide as much detail as possible."
        />
        <MgdDialogFooter>
          <MgdButton :disabled="isSubmitting" type="submit"
            >Submit Report</MgdButton
          >
        </MgdDialogFooter>
      </form>
    </MgdDialogContent>
  </MgdDialog>
</template>
<script setup lang="ts">
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import z from "zod";
import { useBugReportDialog } from "./utils";

const { open } = useBugReportDialog();

const { handleSubmit, resetForm, isSubmitting } = useForm<{
  description: string;
}>({
  name: "BugReportDialog",
  initialValues: {
    description: "",
  },
  validationSchema: toTypedSchema(
    z.object({
      description: z.string().optional(),
    }),
  ),
});

const onSubmit = handleSubmit(async (values) => {
  await sendBugReport(values);
});
const api = useApi();
const {
  mutate: sendBugReport,
  data: bugReportData,
  error: bugReportError,
  reset: resetBugReportMutation,
} = useMutation({
  async mutationFn(data: { description: string }) {
    const response = await api("/api/bug-report", {
      method: "POST",
      body: {
        description: data.description,
      },
    });
    return response;
  },
  onSuccess() {
    resetForm();
  },
});
function onUpdateOpen(value: boolean) {
  open.value = value;
  if (!value) {
    setTimeout(() => {
      resetBugReportMutation();
    }, 250);
  }
}
</script>
